import dayjs from "dayjs";
var calendar = require("dayjs/plugin/calendar");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);
const obj = {
  currencyFormat: (number,decimals = 2) => {
    // // return new Intl.NumberFormat('en-IN', {}).format(number)
    // const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    // const formatted = Number(number).toLocaleString("en", options);
    // return formatted;

    // Convert to string
    if (Math.abs(Number(number)) > 0) {
      const str = number?.toString();

      // Find decimal point position
      const decimalIndex = str?.indexOf(".");

      // If there's no decimal, add zeros
      if (decimalIndex === -1) {
        return str + "." + "0".repeat(decimals);
      }

      // Extract integer + desired decimal digits
      const fixed = str.substring(0, decimalIndex + decimals + 1);

      // If decimal digits are less, pad with zeros
      const decimalPart = fixed?.split(".")[1] || "";
      return fixed + "0".repeat(decimals - decimalPart?.length);
    } else {
      return 0.0;
    }
  },
  dateFormat: (date, timeZone) => {
    var convertedDate = new Date(date).toLocaleString(undefined, {
      timeZone: "Asia/Dhaka", //timeZone ? timeZone :
    });

    return convertedDate.toString();
  },
  msgDateFormat: (date, timeZone) => {
    var convertedDate = new Date(date).toLocaleDateString(undefined, {
      timeZone: timeZone ? timeZone : "Asia/Dhaka",
    });

    return convertedDate.toString();
  },
  timeFormat: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "hh:mm:ss",
    });
  },
  truncateDecimals: (num, digits) => {
    var numS = num.toString(),
      decPos = numS.indexOf("."),
      substrLength = decPos == -1 ? numS.length : 1 + decPos + digits,
      trimmedResult = numS.substr(0, substrLength),
      finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;

    return parseFloat(finalResult);
  },
  canEditUser: (currentUser, targetUser) => {
    // Check if the currentUser has a role exactly 1 higher than the targetUser
    if (currentUser === targetUser + 1) {
      return true;
    }
    return false;
  },
  toFixedWithoutRounding: (num, decimals = 2) => {
    // Convert to string
    if (Math.abs(Number(num)) > 0) {
      const str = num?.toString();

      // Find decimal point position
      const decimalIndex = str?.indexOf(".");

      // If there's no decimal, add zeros
      if (decimalIndex === -1) {
        return str + "." + "0".repeat(decimals);
      }

      // Extract integer + desired decimal digits
      const fixed = str.substring(0, decimalIndex + decimals + 1);

      // If decimal digits are less, pad with zeros
      const decimalPart = fixed?.split(".")[1] || "";
      return fixed + "0".repeat(decimals - decimalPart?.length);
    } else {
      return 0.0;
    }
  },
};

export default obj;
